import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-activities-sms-consumption',
  templateUrl: './activities-sms-consumption.component.html',
  styleUrls: ['./activities-sms-consumption.component.scss']
})
export class ActivitiesSmsConsumptionComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
